import React, { Component } from "react";
import { Box } from "reflexbox";
import { connect } from "react-redux";
import { selectCarrier } from "../../actions/select_actions";

import { HoverCard } from "office-ui-fabric-react/lib/HoverCard";
import { DirectionalHint } from "office-ui-fabric-react/lib/common/DirectionalHint";
import ToggleForm from "../../common/Buttons/_ToggleForm";

class CarrierHoverCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contentRendered: undefined
    };
  }

  _onRenderCompactCard = carrier => {
    this.props.selectCarrier(carrier);
    return (
      <Box m={1}>
        <h3>{carrier.truck + "-" + carrier.trailer}</h3>
      </Box>
    );
  };

  _onRenderExpandedCard = carrier => {
    return (
      <Box m={1}>
        Telefoon 1: {carrier.driver1Tel} <br />
        Telefoon 2: {carrier.driver2Tel} <br />
        Carrier type: {carrier.type} <br />
        Trolleys Section 1: {carrier.trolleysSection1} <br />
        Trolleys Section 1: {carrier.trolleysSection2} <br />
        About: {carrier.about} <br />
        <ToggleForm form="carrier" addOrEdit="edit" disabled={false} />
      </Box>
    );
  };

  render() {
    const expandingCardProps = {
      compactCardHeight: "50",
      expandedCardHeight: "400",
      onRenderCompactCard: this._onRenderCompactCard,
      onRenderExpandedCard: this._onRenderExpandedCard,
      renderData: this.props.carrier,
      directionalHint: DirectionalHint.rightTopEdge,
      gapSpace: 6
    };

    const { carrier } = this.props;

    return (
      <div
        ref={c =>
          !this.state.contentRendered && this.setState({ contentRendered: c })
        }
        data-is-focusable={true}
      >
        <Box>{carrier && carrier.truck + "-" + carrier.trailer}</Box>
        {this.state.contentRendered && (
          <HoverCard
            expandingCardProps={expandingCardProps}
            target={this.state.contentRendered}
            cardOpenDelay={500}
            expandedCardOpenDelay={1000}
            cardDismissDelay={300}
            trapFocus={false}
          />
        )}
      </div>
    );
  }
}

export default connect(null, {
  selectCarrier: selectCarrier
})(CarrierHoverCard);



// WEBPACK FOOTER //
// ./src/views/Carriers/_CarrierHoverCard.js